export const SERVER_MESSAGE = false;